import React from 'react';
import { Dialog, DialogHeader, DialogTitle, DialogContent } from '../../ui-v2';

/**
 * ModalVideoTutorial — modal con el vídeo de Vimeo "cómo reservar tu cita".
 * Específico del módulo (no va en ui-v2). Usa el Dialog de ui-v2 (size xl).
 *
 * El iframe SOLO existe con el modal abierto:
 *  - ui-v2/Dialog.jsx:37 hace `if (!open) return null` → desmonta a sus hijos.
 *  - Además envolvemos el iframe en `{open && (...)}` como cinturón-y-tirantes,
 *    para que el reproductor de Vimeo NUNCA se cargue en background.
 */
export default function ModalVideoTutorial({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} size="xl">
      <DialogHeader>
        <DialogTitle>Cómo reservar tu cita</DialogTitle>
      </DialogHeader>
      <DialogContent>
        {open && (
          <div className="aspect-video w-full">
            <iframe
              src="https://player.vimeo.com/video/1217589761?dnt=1&title=0&byline=0&portrait=0&autoplay=1"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Vídeo: cómo reservar tu cita técnica"
              className="w-full h-full"
              style={{ border: 0 }}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
